import React, { useState , useRef } from "react";
import { usePFDataContext } from "../context/PfContext";

import {ajaxURL} from '../variables';




const CartUserInput = ({ toggleCart }) => {
    const { pfData, showAlert } = usePFDataContext();    

    const [name, setName] = useState('');
    const [storeName, setStoreName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [storeEmail, setStoreEmail] = useState('');

    // Refs to input elements for validation
    const storeEmailRef = useRef(null);
    const nameInputRef = useRef(null);
    const storeNameRef = useRef(null);
    const emailRef = useRef(null);
    const phoneRef = useRef(null);
    const messageRef = useRef(null);

    const handleValidation = () => {
        let isValid = true;

        // Email regex pattern for validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Validate name field
        if (!name.trim()) {
            nameInputRef.current.classList.add("error");
            isValid = false;
        } else {
            nameInputRef.current.classList.remove("error");
        }

        // Validate store name field
        if (!storeName.trim()) {
            storeNameRef.current.classList.add("error");
            isValid = false;
        } else {
            storeNameRef.current.classList.remove("error");
        }

        // Validate email field
        if (!email.trim() || !emailPattern.test(email)) {
            emailRef.current.classList.add("error");
            isValid = false;
        } else {
            emailRef.current.classList.remove("error");
        }

        // Validate phone field
        if (!phone.trim()) {
            phoneRef.current.classList.add("error");
            isValid = false;
        } else {
            phoneRef.current.classList.remove("error");
        }

         // Validate store email field
         if (!storeEmail) {
            if (storeEmailRef.current) storeEmailRef.current.classList.add("error");
            isValid = false;
        } else {
            if (storeEmailRef.current) storeEmailRef.current.classList.remove("error");
        }

        return isValid;
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        if (handleValidation()) {

            if(pfData.cart.products.length > 0) {
                // Proceed with form submission
                // ajax pf_cart_submit
                console.log('Form submitted successfully');
                let form = new FormData();
                form.append('action', 'pf_cart_submit');
                form.append('name', name);
                form.append('store_name', storeName);
                form.append('email', email);
                form.append('phone', phone);
                form.append('message', message);
                form.append('store_email', storeEmail);
                form.append('cart', JSON.stringify(pfData.cart));

                fetch(ajaxURL, {
                    method: 'POST',
                    body: form
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then(data => {
                        console.log('Data:', data);
                        if (data.status === 'success') {
                            showAlert(data.message || 'Form submitted successfully');
                        } else {
                            showAlert(data.message || 'Error submitting form');
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        showAlert('Error submitting form');
                    })
                    .finally(() => {
                        // Close the cart
                        toggleCart();
                    });

            } else {
                showAlert('No items in cart.');
            }

        } else {
            console.log('Form validation failed');
        }
    };


    return(
        <div className="flyout__cart--form-user-group">
        <div className="flyout__cart-form-input--row">
            <div className="flyout__cart-form-input--row-inner">
                <label htmlFor="store_email">Store Email:</label>
                <select 
                    name="store_email" 
                    id="store_email" 
                    className="flyout__cart-form--input"
                    ref={storeEmailRef}
                    value={storeEmail}
                    onChange={(e) => setStoreEmail(e.target.value)}
                >
                    <option value="">Select Store Email</option>
                    {/* Add dynamic options here */}
                    {pfData.storeEmails.default &&  <option value={pfData.storeEmails.default}>I am not sure </option>}
                    {pfData.storeEmails.emails && pfData.storeEmails.emails.map((email) => (
                        <option key={email} value={email}>
                            {email}
                        </option>
                    ))}
                </select>
            </div>
            {!storeEmail && <div className="error-message">This field is required</div>}
            </div>
        <div className="flyout__cart-form-input--row">
            <div className="flyout__cart-form-input--row-inner">
                <label htmlFor="name">Your Name:</label>
                <input 
                    ref={nameInputRef}
                    type="text" 
                    id="name" 
                    className="flyout__cart-form--input" 
                    placeholder="Your Name" 
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
            </div>
            {!name.trim() && <div className="error-message">This field is required</div>}
      
        </div>
        <div className="flyout__cart-form-input--row">
            <div className="flyout__cart-form-input--row-inner">
                <label htmlFor="store_name">Store Name:</label>
                <input 
                    ref={storeNameRef}
                    type="text" 
                    id="store_name" 
                    className="flyout__cart-form--input" 
                    placeholder="Store Name" 
                    value={storeName}
                    onChange={(e) => setStoreName(e.target.value)}
                />
            </div>
            {!storeName.trim() && <div className="error-message">This field is required</div>}
        </div>
        <div className="flyout__cart-form-input--row">
            <div className="flyout__cart-form-input--row-inner">
                <label htmlFor="email">Email:</label>
                <input 
                    ref={emailRef}
                    type="email" 
                    id="email" 
                    className="flyout__cart-form--input" 
                    placeholder="Email" 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
            </div>
            {!email.trim() && <div className="error-message">This field is required</div>}
                {email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && (
                    <div className="error-message">Invalid email address</div>
                )}

        </div>
        <div className="flyout__cart-form-input--row">
            <div className="flyout__cart-form-input--row-inner">
                <label htmlFor="phone">Phone:</label>
                <input 
                    ref={phoneRef}
                    type="text" 
                    id="phone" 
                    className="flyout__cart-form--input"
                    placeholder="Phone" 
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                />
            </div>
            {!phone.trim() && <div className="error-message">This field is required</div>}
        </div>
        <div className="flyout__cart-form-input--row flyout__cart-form-input-notes--row">
            <label htmlFor="message">Notes:</label>
            <textarea 
                id="message" 
                cols="30" 
                rows="10" 
                className="flyout__cart-form--input" 
                placeholder="Notes" 
                value={message}
                onChange={(e) => setMessage(e.target.value)}
            />
        </div>
        <button type="submit" onClick={handleSubmit}>
            Submit
        </button>
    </div>
    )
}

export default CartUserInput;